import { Alert } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledDivAlert = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(spacingSizeMap.M),
}));

type OrganisationRemovalWarningProps = {
  selectedGroupName: string;
};

const OrganisationRemovalWarning = ({
  selectedGroupName,
}: OrganisationRemovalWarningProps) => {
  const { t } = useTranslation();
  return (
    <StyledDivAlert>
      <Alert severity="info">
        {t('ui.event-management.organisations.remove.from-group-message', {
          selectedGroup: selectedGroupName,
        })}
      </Alert>
    </StyledDivAlert>
  );
};

export default OrganisationRemovalWarning;
